import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { findError } from '@/utils/errors';
import fields from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import FormInput from '@/forms/components/FormInput';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import { catalogueTitleField } from '../helper';

const CatalogueTitleInput = ({
  autoFocus,
  category,
  className,
  code,
  errorCoordinate = 't-30',
  icon,
  size,
  withValidation,
}) => {
  const intl = useIntl();
  const { name, saveErrors, template } = Selectors.useCatalogueTitleInput({ category, code });
  const updateName = Events.useUpdateDatasetCatalogueTitle(category, { code });
  const error = findError(saveErrors, 'catalogue', [fields.NAME]);

  return (
    <>
      <FormInput
        autoFocus={autoFocus}
        field={catalogueTitleField(intl)}
        text={name}
        icon={icon}
        iconPosition={icon ? 'left' : undefined}
        size={size}
        onChange={(value) => updateName({ value, template })}
        error={error}
        className={clsx('aridhia-catalogue-title-input', className)}
      />
      {withValidation && (
      <ValidationSpan validationError={error} position="bottom" errorCoordinate={errorCoordinate} />
      )}
    </>
  );
};

export default CatalogueTitleInput;
